import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="border-y border-slate-200 bg-slate-50 px-4 py-12 md:py-14" data-id="element-51" data-mp="2e067y48snqwi">
      <div className="mx-auto max-w-3xl" data-id="element-52" data-mp="2dy3gdfrztppo">
        <Eyebrow data-id="element-53" data-mp="292efn948m2rs">
          <span className="inline-flex items-center gap-2" data-id="element-54" data-mp="291wbzrf8wm9u">
            <HelpCircleIcon className="h-4 w-4" data-id="element-55" data-mp="241qpsqrqvrz5" /> FAQ
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-56" data-mp="1z3fgqi99xlhz">Frequently Asked Questions</SectionTitle>
        <p className="mt-3 text-center text-sm font-semibold text-slate-600 md:text-base" data-id="element-57" data-mp="1z2xen4zxkd25">
          What people usually want to know
        </p>
        <div className="mt-8 space-y-3" data-id="element-58" data-mp="nniho17q1l71">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-blue-950 shadow-lg shadow-slate-200' : 'border-slate-200'}`} data-id="element-59" data-mp="pheje3b0vdfv" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-5 text-left text-sm font-extrabold text-blue-950 md:text-base" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-60" data-mp="flupfmg0qotr">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-yellow-700 transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-61" data-mp="3syodkgmulb41" />
              </button>
              <AnimatePresence initial={false} data-id="element-62" data-mp="3jxgfnzo8ucah">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-slate-200 px-5 py-4 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-63" data-mp="3nzbrhy3sw82i">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}